import { createModel } from '@rematch/core';
import reducers from './reducers';
import state from './state';
import { type RootModel } from './..';

const cache = createModel<RootModel>()({
  name: 'cache',
  state,
  reducers,
});

export default cache;
